var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{class:{ active: _vm.connected, inactive: !_vm.connected, 'connect-btn': true }},[_c('button',{on:{"click":_vm.toggleConnection}},[_vm._v(" "+_vm._s(_vm.connectButtonString)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }